<template>
  <div
    class="flex flex-col items-start gap-[10px] p-[10px] rounded-[6px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF]"
  >
    <!-- {{ item.shelter_has }} -->
    <div class="w-full flex gap-[10px]">
      <div
        class="min-w-[48px] min-h-[48px] w-[48px] h-[48px] border-[1px] border-solid border-[#F2E7F9]"
      >
        <img :src="item.image_path || 'https://placehold.co/48x48/png'" alt="" />
      </div>
      <div class="w-[calc(81%-1rem)] h-[72px] flex flex-col gap-[4px]">
        <div class="PC_Body1-R !text-[#1F1D1F] truncate">
          {{ item.name }}
        </div>
        <div class="cardLabel truncate">
          {{ item.unit_name }}
        </div>
        <div class="cardLabel truncate">
          {{ item.category_name }}
        </div>
      </div>
    </div>
    <div class="w-full flex flex-col items-end justify-center gap-[10px]">
      <div
        v-if="item.request != '-1.00'"
        class="w-full h-[4px] bg-[#EECCE7] rounded overflow-hidden"
      >
        <div
          class="h-full bg-[#9B237B] transition-all duration-500"
          :style="{ width: progressPercent + '%' }"
        ></div>
      </div>
      <div v-else class="w-full h-[4px] bg-[#F3F2F2] rounded overflow-hidden"></div>
      <div class="w-full h-[69px] flex flex-col items-end">
        <div
          class="w-full flex items-center gap-[4px] p-[4px] PC_Body2-R text-[#9B237B] bg-[#FBEFF8]"
        >
          <span> ต้องการอีก </span>
          <span>:</span>
          <span class="max-w-[155px] truncate" v-if="item.request != '-1.00'">
            {{ $numberAndComma(item.needed) }}
          </span>
          <span v-else> ไม่จำกัด </span>
        </div>
        <div class="flex gap-[4px] labelL">
          <span> ยอดร้องขอ </span>
          <span>:</span>
          <span v-if="item.request != '-1.00'">
            {{ $numberAndComma(item.request) || "0" }}
          </span>
          <span v-else> ไม่จำกัด </span>
        </div>
        <div class="flex gap-[4px] labelL">
          <span> ยอดที่ได้รับ </span>
          <span>:</span>
          <span>
            {{ $numberAndComma(item.quantity) || "0" }}
          </span>
        </div>
      </div>

      <div class="w-full h-[1px] bg-[#DFDCDD]"></div>
      <div class="w-full flex items-center justify-between gap-[8px]">
        <div class="labelL">
          {{ `อัปเดตเมื่อ ${$formatDate2(item.updated_at)}` }}
        </div>
        <div class="labelL">
          {{ $formatTime1(item.updated_at) }}
        </div>
      </div>
    </div>
    <div
      v-if="auth.hasRole([ROLES.staff])"
      class="w-full flex items-center gap-[4px] self-stretch"
    >
      <ButtonComponent :label="'ยุติคำขอ'" :bClass="'btn_shadow--32'" @clicked="cancel" />
      <ButtonComponent :label="'แก้ไข'" :bClass="'btn_shadow--12s'" @clicked="edit" />
      <ButtonComponent
        :label="'ยอดที่ได้รับ'"
        :bClass="'btn_shadow--12s'"
        @clicked="update"
      />
    </div>
    <div
      v-if="auth.hasRole([ROLES.admin]) && version == 2"
      class="w-full flex items-center gap-[4px] self-stretch"
    >
      <ButtonComponent
        :disabled="item.shelter_has == 0"
        :label="'ส่งมอบของ'"
        :bClass="[
          'btn_shadow--12s',
          item.shelter_has == 0 ? '!bg-[#FFF] !text-[#DFDCDD]' : '',
        ]"
        @clicked="transfer"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useAuthStore } from "@/pinia/authStore";
// โรล
import { ROLES } from "@/components/Utilities/javascripts/permissions";

const auth = useAuthStore();

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  version: { type: [String, Number], default: 1 },
  permission: { type: Boolean, default: true },
});

const progressPercent = computed(() => {
  if (!props.item.request) return 0;
  return (props.item.quantity / props.item.request) * 100;
});

const emit = defineEmits(["cancel", "edit", "update", "transfer"]);

const cancel = () => {
  emit("cancel", props.item);
};

const edit = () => {
  emit("edit", props.item);
};

const update = () => {
  emit("update", props.item);
};

const transfer = () => {
  emit("transfer", props.item);
};
</script>

<style lang="scss" scoped>
.labelL {
  color: var(--text-color-text-grey-darkest, #1f1d1f);
  text-align: right;
  /* Resource card/label L */
  font-family: Kanit;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 153.846% */
  letter-spacing: 0.1px;
}
@media screen and (max-width: 64rem) {
  .PC_Body1-R {
    font-size: 16px !important;
  }
}
</style>
